import angular from 'angular'

import CsvService from './csv.service'

export default angular.module('app.services.csv', [])
  .service('csvService', CsvService)
